import React from 'react'
import CIcon from '@coreui/icons-react'
import { 
  cilPen,
  cilImage,
  cilGroup,
  cilFolder,
  cilChart,
  cilCalendar,
  cilCart,
  cilPeople,
  cilShare,
  cilPlus,
} from '@coreui/icons'
import { FaPrayingHands, FaTachometerAlt } from 'react-icons/fa'
import { CNavItem, CNavTitle } from '@coreui/react'
import { useAuth } from "../../hooks/useAuth";

// ✅ Fonction qui retourne la navigation selon le statut partenaire
export const useBackNav = () => {
  const { getIsPartner } = useAuth(); // Hook personnalisé pour auth
  const isPartner = getIsPartner(); // ⚠️ Note les parenthèses pour appeler la fonction

  const back_nav = [
    {
      component: CNavItem,
      name: 'Tableau de bord',
      to: '/dashboard',
      icon: <FaTachometerAlt className="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Ma Progression',
      to: '/dashboard/progression',
      icon: <CIcon icon={cilChart} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Mon espace prière',
      to: '/dashboard/espace-priere',
      icon: <FaPrayingHands className="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Journal Spirituel',
      to: '/dashboard/journal',
      icon: <CIcon icon={cilPen} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Calendrier',
      to: '/dashboard/calendrier',
      icon: <CIcon icon={cilCalendar} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Communauté',
      to: '/dashboard/communaute',
      icon: <CIcon icon={cilGroup} customClassName="nav-icon" />,
    },

    ...(isPartner
        ? [
          {
            component: CNavTitle,
            name: 'Espace Partenaire',
          },
          {
            component: CNavItem,
            name: 'Gestion des Membres',
            to: '/dashboard/mymember',
            icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
          },
          {
            component: CNavItem,
            name: 'Marketplace Zayado',
            to: 'https://zayado.net',
            icon: <CIcon icon={cilCart} customClassName="nav-icon" />,
          },
          {
            component: CNavItem,
            name: 'Intercessions Clients',
            to: '/dashboard/intercessions-clients',
            icon: <FaPrayingHands className="nav-icon" />,
          },
          {
            component: CNavItem,
            name: 'Impact Evangélique',
            to: '/dashboard/impact-evengelique',
            icon: <CIcon icon={cilShare} customClassName="nav-icon" />,
          },
          {
            component: CNavItem,
            name: 'Gestion des Services',
            to: '/dashboard/services',
            icon: <CIcon icon={cilPlus} className="nav-icon" />,
          },
        ]
        : []),

    {
      component: CNavTitle,
      name: 'Ressources',
    },
    {
      component: CNavItem,
      name: 'Ressources',
      to: '/dashboard/ressources',
      icon: <CIcon icon={cilFolder} customClassName="nav-icon" />,
    },
    {
      component: CNavItem,
      name: 'Galerie',
      to: '/dashboard/galerie',
      icon: <CIcon icon={cilImage} customClassName="nav-icon" />,
    },
  ];

  return back_nav;
};
